<script>
    import groups from "../stores/groups";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import {GROUP_TYPE} from "../lib/constants";
    import {groupDelete} from "../requests";
    import {createEventDispatcher} from 'svelte/internal';


    export let group;
    export let selected = false;
    export let allowActions = true;

    const dispatch = createEventDispatcher();

    const selectGroup = () => {
        //group.selected = true;
        dispatch('select', group);
    }

    const deleteGroup = () => {
        app_alert.show('confirm', `Να διαγραφεί η ομάδα "${group.name}";`, async () => {
            const [err, res] = await groupDelete(group.id);
            if (err) {
                return;
            }
            groups.deleteGroup(group.id);
            success.show("Η ομάδα διαγράφτηκε.");
        });
    }

</script>
<div class="group-select-control" class:checked={ selected } on:click="{ selectGroup }">
    <div class="icon">
        <i class="fa fa-users"></i>
    </div>
    <div class="label">
        { group.name }
        {#if group.total_mobiles != 'null' && group.total_mobiles > 0 }
            <div class="total-phones">{ group.total_mobiles } { group.type == GROUP_TYPE.GROUP_MEMBERS ? 'επαφές' : 'τηλέφωνα' }</div>
        {/if}
    </div>

    {#if allowActions}
        <div class="action action-edit" class:action-hide={ selected } title="Επεξεργασία ομάδας"
             on:click|stopPropagation="{ () => groups.editGroup(group.id) }"><i class="fa fa-edit"></i></div>
        <div class="action action-delete" class:action-hide={ selected } title="Διαγραφή ομάδας"
             on:click|stopPropagation="{ deleteGroup }"><i class="fa fa-trash-o"></i></div>
    {/if}
</div>

<style>
    .group-select-control {
        position: relative;
        background: #fff;
        font-size: 14px;
        color: #767676;
        border: 1px solid #f3f3f3;
        border-radius: 3px;
        padding: 10px 15px;
        margin-top: 2px;
        overflow: hidden;
        cursor: pointer;
    }

    .group-select-control:after {
        content: "";
        clear: both;
        display: table;
    }

    .group-select-control .icon {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 30px;
        max-width: 0;
        background: #efefef;
        font-size: 10px;
        padding-top: 2px;
        opacity: 0;
        overflow: hidden;
        transition: .1s all ease;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }

    .group-select-control .icon i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .group-select-control .label {
        width: 100%;
        max-width: 100%;
        transition: .1s all ease;
    }

    .group-select-control .label .total-phones {
        font-size: 12px;
        color: #a5a5a5;
    }

    .group-select-control.checked {
        /*background: #f1f1f1;*/
        color: #000;
        border-color: #e4e4e4;
    }

    .group-select-control.checked .icon {
        max-width: 40px;
        opacity: 1;
    }

    .group-select-control.checked .label {
        transition: .1s all ease;
        padding-left: 25px;
    }

    .group-select-control .action {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        width: 40px;
        color: #767676;
        background: #fff;
        border-left: 1px solid #f3f3f3;
        padding: 5px 8px;
        transition: .1s all ease;
        cursor: pointer;
    }

    .group-select-control .action:hover {
        color: #757575;
        background: #eee;
    }

    .group-select-control .action i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .group-select-control .action.action-edit {
        right: 40px;
    }

    .group-select-control .action.action-delete {
        color: #ff0000;
    }

    .group-select-control .action.action-hide {
        right: -40px;
    }
</style>